// extracted by mini-css-extract-plugin
export default {"container":"HdL_v","header":"LCyUb","content":"SCvaX","my-alerts":"_2dyb","my-performance":"sQD2p","my-pms-matters":"VqjUD","my-live-matters":"yIdu4","my-pms-matters-body":"YoSIR"};